import assets from "./assets";
import snapshots from "./snapshots";
import users from "./users";

export default {
  ...assets,
  modules: {
    snapshots,
    users
  }
};
